import { usePortalStore, usePortalMode } from '@servicetitan/cp-ui';
import { Button, Card } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { FC, SyntheticEvent } from 'react';
import {
    AgreementStatus,
    DashboardServiceAgreementsData,
    ESignStatus,
} from '../../../api/portal-dashboard.api';
import { ReadyToSignServiceAgreementContent } from './ready-to-sign-service-agreement-content';
import * as Styles from './service-agreement-dashboard.module.less';
import { ServiceAgreementCoveredLocationsDrawerStore } from './service-agreement-drawer/stores/service-agreement-covered-locations-drawer.store';
import { ServiceAgreementMapUrls } from './service-agreement-url-map';

interface ScheduledServiceAgreementsListItemProps {
    serviceAgreement: DashboardServiceAgreementsData;
}

export const ServiceAgreementsListItem: FC<ScheduledServiceAgreementsListItemProps> = observer(
    props => {
        const { serviceAgreement } = props;
        const mode = usePortalMode();
        const [coveredLocationsStore] = useDependencies(
            ServiceAgreementCoveredLocationsDrawerStore
        );
        const { event } = usePortalStore();

        const serviceAgreementId = Number(serviceAgreement?.id ?? 0);
        const serviceAgreementHref = `${ServiceAgreementMapUrls.list}/${serviceAgreementId}`;
        const serviceAgreementEsignHref = `${ServiceAgreementMapUrls.list}/${serviceAgreementId}/esign`;

        const viewServiceAgreement = (e: SyntheticEvent<HTMLElement>) => {
            if (coveredLocationsStore.isOpen) {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
            event('redirect', ['service-agreements', { itemId: Number(serviceAgreementId) }]);
        };

        const viewServiceAgreementEsign = (e: SyntheticEvent<HTMLElement>) => {
            if (coveredLocationsStore.isOpen) {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
            event('redirect', ['service-agreements-esign', { itemId: serviceAgreementId }]);
        };

        const esignRequired =
            serviceAgreement.eSignStatus === ESignStatus.Required &&
            serviceAgreement.status === AgreementStatus.Sent;

        const viewServiceAgreementButton = esignRequired ? (
            <Button
                fill="solid"
                primary
                size="small"
                href={serviceAgreementEsignHref}
                onClick={viewServiceAgreementEsign}
            >
                View & Sign Agreement
            </Button>
        ) : (
            <Button
                fill="subtle"
                primary
                size="small"
                href={serviceAgreementHref}
                onClick={viewServiceAgreement}
            >
                View Agreement
            </Button>
        );

        return (
            <div className={Styles.cardListItem}>
                <Card
                    className={Styles.hiddenClickableCard}
                    onClick={viewServiceAgreement}
                    padding="none"
                >
                    <ReadyToSignServiceAgreementContent
                        serviceAgreement={serviceAgreement}
                        mobile={mode.mobile}
                        viewServiceAgreementButton={viewServiceAgreementButton}
                    />
                </Card>
            </div>
        );
    }
);
